import { apiInstance } from '@/api/api.js'

const api = apiInstance()

export default {
  async getPrograms({ commit, dispatch }, { companyId, active }) {
    try {
      commit('setLoading', true)
      const response = await api.get('/programs', {
        params: {
          companyId,
          active,
        },
      })
      commit('setPrograms', response.data)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },

  async createProgram({ commit, dispatch }, { name, description }) {
    try {
      commit('setLoading', true)
      const response = await api.post('/programs', {
        name,
        description,
      })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Program created!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async getProgram({ commit, dispatch }, { id }) {
    try {
      commit('setLoading', true)
      const response = await api.get(`/programs/${id}`)
      commit('setProgram', response.data)
      commit('setLoading', false)
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async updateProgram({ commit, dispatch }, { id, name, description, active }) {
    try {
      commit('setLoading', true)
      const response = await api.put(`/programs/${id}`, {
        name,
        description,
        active,
      })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Program updated!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async deleteProgram({ commit, dispatch }, { id }) {
    try {
      commit('setLoading', true)
      const response = await api.delete(`/programs/${id}`)
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Program deleted!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async assignProgramsToProfile({ commit, dispatch }, { profileId, programs }) {
    try {
      commit('setLoading', true)
      const response = await api.put(`/profiles/${profileId}/programs`, {
        programs,
      })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Programs assigned!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async unassignProfilesFromProgram(
    { commit, dispatch },
    { id, companyId, profiles },
  ) {
    try {
      commit('setLoading', true)
      const response = await api.post(
        `/programs/${id}/unassign`,
        {
          profiles,
        },
        {
          params: {
            companyId,
          },
        },
      )
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Profiles unassigned!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async assignProfilesToProgram(
    { commit, dispatch },
    { id, companyId, profiles },
  ) {
    try {
      commit('setLoading', true)
      const response = await api.post(
        `/programs/${id}/assign`,
        {
          profiles,
        },
        {
          params: {
            companyId,
          },
        },
      )
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Profiles assigned!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async assignProgramsToPracticeParticipants(
    { commit, dispatch },
    { practiceId, programs },
  ) {
    try {
      commit('setLoading', true)
      const response = await api.put(
        `/practices/${practiceId}/participants/programs`,
        { programs },
      )
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Programs assigned!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },
}
